export default {
  FullHeadCovering: 1,
  PartialHeadCovering: 2,
  NoHeadCovering: 3,
  Wig: 4,
  Other: 8,
};
